import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-listing.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * Listing Component
 * @element ghs-listing
 */
@customElement('ghs-listing')
export class GhsListing extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="listing">
        <slot></slot>
      </div>
    `;
  }
}
